import { render, staticRenderFns } from "./PasswordDashboard.vue?vue&type=template&id=d2d21150&scoped=true&"
import script from "./PasswordDashboard.vue?vue&type=script&lang=js&"
export * from "./PasswordDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PasswordDashboard.vue?vue&type=style&index=0&id=d2d21150&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d21150",
  null
  
)

export default component.exports